import React from 'react';
import {Navigate} from 'react-router-dom';
import {useAuth} from './AuthContext';

export default function ProtectedRoute({children}) {
    const {user} = useAuth();
    console.log(user)
    if (user === undefined) return null; // Или return <Spinner />
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
